var angular = require('angular')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en
var guid = require('aem-libs/src/guid')

require('angular-sanitize')

angular.module('OwInputCheckboxGdprCmp', ['ngSanitize'])
  .component('owInputCheckboxGdpr', {
    template: require('./ow-input-checkbox-gdpr.component.tpl.html'),
    controller: OwInputCheckboxGdprCtrl,
    controllerAs: 'vm',
    bindings: {
      formFieldId: '<',
      value: '<',
      errorMessages: '<',
      options: '<',
      label: '<',
      onChanged: '&'
    }
  })

OwInputCheckboxGdprCtrl.$inject = ['i18n', '$timeout']

function OwInputCheckboxGdprCtrl (i18n, $timeout) {
  var vm = this

  vm.$onInit = function () {
    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)
    vm.id = vm.formFieldId + '-' + guid()
    vm.model = !!vm.value
    vm.changed = changed
    $timeout(processErrors)
  }

  vm.$onChanges = function (changesObj) {
    if (changesObj.value) {
      vm.model = !!vm.value
    }
    if (changesObj.errorMessages) {
      $timeout(processErrors)
    }
  }

  function processErrors () {
    if (angular.isArray(vm.errorMessages)) {
      // reset current errors
      Object.keys(vm.form.field.$error).forEach(function (error) {
        vm.form.field.$setValidity(error, true)
      })
      // set external errors
      vm.errorMessages.forEach(function (error) {
        vm.form.field.$setValidity(error, false)
      })
    }
  }

  function changed () {
    var value = ''
    if (vm.model) {
      value = vm.options[0]
    }
    vm.onChanged({ value: value, formFieldId: vm.formFieldId })
  }
}
